<template>
	<div class="ui-badge" :class="[design, { bordered: border }]" :style="[styles, radiusComputed]">
		<abbr class="abbreviation text" v-if="abbreviation" :title="abbreviation">
			{{ abbreviationComputed }}
			<slot></slot>
		</abbr>

		<abbr class="abbreviation text" v-else-if="initials" :title="initials">
			{{ initialsComputed }}
			<slot></slot>
		</abbr>

		<span class="text" v-else>
			{{ textComputed }}
			<slot></slot>
		</span>
	</div>

	<!-- 
        Modo de Uso

        import uiBadge from "@/components/ui/badge"
        components: {
            uiBadge,
        },

        <ui-badge text="Seu texto vai aqui" />
        <ui-badge text="Seu texto vai aqui" color="blue" />
        <ui-badge abbreviation="Seu texto vai aqui" color="green" design="sm" />
        <ui-badge abbreviation="Seu texto vai aqui" color="#eee" design="md" />
        <ui-badge initials="Nome de Alguem" color="#222" design="lg" /> 
    -->
</template>

<script>
	export default {
		props: {
			text: {
				type: [String, Number],
				required: false,
				default: '',
			},

			abbreviation: {
				type: String,
				required: false,
				default: '',
			},

			initials: {
				type: String,
				required: false,
				default: '',
			},

			design: {
				type: String,
				required: false,
				default: 'md',
			},

			color: {
				type: String,
				required: false,
				default: '#f6f7fb',
			},

			border: {
				type: Boolean,
				required: false,
				default: false,
			},

			radius: {
				type: Number,
				required: false,
				default: 3,
			},
		},

		data: function () {
			return {
				uiColor: null,
			}
		},

		computed: {
			styles() {
				if (this.border) return { 'border-color': this.color, color: this.color }
				else return { 'background-color': this.color, color: this.uiColor }
			},

			textComputed: {
				get() {
					return this.text
				},

				set(value) {
					this.setContrastColor(value)
				},
			},

			radiusComputed() {
				return { 'border-radius': this.radius + 'px' }
			},

			/**
			 * Retorna apenas a primeria letra de cada palavra da string
			 */
			abbreviationComputed: {
				get() {
                    const match = this.abbreviation
						.replace(/[^a-zA-Z ]/g, '')
						.match(/\b(\w)/g)

					return match ? match.join('').toUpperCase() : this.abbreviation.charAt(0)
				},

				set(value) {
					this.setContrastColor(value)
				},
			},

			/**
			 * Retorna a primeira letra da primeira e da ultima palavra
			 */
			initialsComputed: {
				get() {
					let fullName = this.initials.replace(/[^a-zA-Z ]/g, '').split(' ')
					let initials = ''

					if (fullName.length < 2) {
						initials = fullName.shift().charAt(0)
					} else {
						initials = fullName.shift().charAt(0) + fullName.pop().charAt(0)
					}

					return initials.toUpperCase()
				},

				set(value) {
					this.setContrastColor(value)
				},
			},
		},

		methods: {
			setContrastColor: function () {
				var getContrast = function (hexcolor) {
					// If a leading # is provided, remove it
					if (hexcolor.slice(0, 1) === '#') {
						hexcolor = hexcolor.slice(1)
					}

					// If a three-character hexcode, make six-character
					if (hexcolor.length === 3) {
						hexcolor = hexcolor
							.split('')
							.map(function (hex) {
								return hex + hex
							})
							.join('')
					}

					// Convert to RGB value
					var r = parseInt(hexcolor.substr(0, 2), 16)
					var g = parseInt(hexcolor.substr(2, 2), 16)
					var b = parseInt(hexcolor.substr(4, 2), 16)

					// Get YIQ ratio
					var yiq = (r * 299 + g * 587 + b * 114) / 1000

					// Check contrast
					return yiq >= 128 ? 'black' : 'white'
				}

				this.uiColor = getContrast(this.color)
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
